export const ARCHIVE_NEEDS_DELETE_REASON = "Archiving needs delete permission.";

export function archiveBlockedInSplitOrMergeReason(input: {
  canDelete: boolean;
  inSplitOrMerge: boolean | undefined;
}): string | null {
  if (input.canDelete) return null;
  return input.inSplitOrMerge === true ? ARCHIVE_NEEDS_DELETE_REASON : null;
}
